import { render } from "./Spec.vue?vue&type=template&id=1d972c4c"
import script from "./Spec.vue?vue&type=script&lang=js"
export * from "./Spec.vue?vue&type=script&lang=js"
script.render = render

export default script